import {createSelector} from 'reselect';

import {URGENCY_REWORDING_FF} from './constants';

const gsConfigSelector = (state) => (state && state.gsConfig) || {};

const featureFlagsSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.features || {});

export const urgencyMessagingSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => features[URGENCY_REWORDING_FF]
);
